/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const ConversationsGroupBy = {
  UserId: "user_id",
  ApiKeyId: "api_key_id",
  OrgId: "org_id",
} as const;
export type ConversationsGroupBy = ClosedEnum<typeof ConversationsGroupBy>;

/** @internal */
export const ConversationsGroupBy$inboundSchema: z.ZodNativeEnum<
  typeof ConversationsGroupBy
> = z.nativeEnum(ConversationsGroupBy);
/** @internal */
export const ConversationsGroupBy$outboundSchema: z.ZodNativeEnum<
  typeof ConversationsGroupBy
> = ConversationsGroupBy$inboundSchema;
